import { render } from "./SettingsSubscription.vue?vue&type=template&id=3fde8b54"
import script from "./SettingsSubscription.vue?vue&type=script&lang=js"
export * from "./SettingsSubscription.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__